export const SHIPPING_ACTION_LINK_SX = {
    p: 0,
    minWidth: "unset",
    textTransform: "none",
    fontFamily: "'Rubik', sans-serif",
    fontSize: "12px",
    fontWeight: 500,
    cursor: "pointer",
    alignSelf: "flex-start",
    color: "#010101",
    textDecoration: "underline",
    display: "inline-flex",
    justifyContent: "flex-start",

    // clave para que "Ver en mapa" no se corte
    whiteSpace: "nowrap",
    flexShrink: 0,

    "& .MuiButton-startIcon": {
        mr: "4px",
        flexShrink: 0,
    },
    "&:hover": {
        backgroundColor: "transparent",
        color: "#666",
        textDecoration: "underline",
    },
} as const;














